<template>
  <page :breadcrumbBar="false" :manualInit="initStatus" @reload="initWidget">
    <div slot="title" class="dashTitle">
      <div class="pageTitle">
        <date-display></date-display>
      </div>
    </div>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn flat color="secondary" slot="activator" title="Guide for Dashboard" id="guideBtn">
            Guide
            <v-icon right>mdi-television-guide</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile avatar @click="startTour()">
              <v-list-tile-avatar>
                <v-icon>mdi-presentation-play</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>Quick Tour</v-list-tile-title>
            </v-list-tile>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>mdi-file-document</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>Documentation</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu offset-y :close-on-content-click="false" v-model="widgetMenu" :lazy="true" :min-width="300" :max-height="500">
          <v-btn flat color="secondary" slot="activator" id="widgetsBtn" title="Add/Remove Widget">
            Widgets
            <v-icon right>mdi-view-quilt</v-icon>
          </v-btn>
          <widget-menu></widget-menu>
        </v-menu>
      </div>
    </div>
    <div class="dashboard">
      <grid-layout :layout="widgets" :col-num="12" :row-height="150" :is-draggable="true" :is-resizable="true" :is-mirrored="false" :vertical-compact="true" :margin="[10, 10]" :use-css-transforms="true" @layout-updated="layoutUpdatedEvent" :verticalCompact="true">
        <grid-item v-for="item in widgets" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :minW="item.minW" :minH="item.minH" :i="item.i" :isResizable="item.isResizable" :key="item.i" dragIgnoreFrom="a, button, input">
          <component :is="item.component"></component>
        </grid-item>
      </grid-layout>
    </div>
    <tour ref="tour" :tour="tour"></tour>
  </page>
</template>

<script>
import { mapActions } from 'vuex'
import { GridLayout, GridItem } from 'vue-grid-layout'
import { widgets as widgetsParam } from './widgets'
import WidgetMenu from './widgets/WidgetMenu'
import DateDisplay from './DateDisplay'
import DashBoardTour from '@/const/tour/dashboard'

export default {
  data() {
    return {
      widgetMenu: false,
      // Note that the object variable name is strict to i, x, y, w, h etc
      widgets: [],
      tour: DashBoardTour
    }
  },
  watch: {
    'globalWidgets': function (value) {
      if (this.widgets.length > 0) {
        // we can just do convertWidgetState (not optimal as it will reload all the widgets)
        // Need find out what is added / removed
        // as we cannot watch for oldValue for vuex state, we will compare it to our local state
        if (value.length > this.widgets.length) {
          // Added
          let diff = value.filter(x => !this.widgets.find(a => x.i === a.i))
          if (diff && diff.length > 0) {
            if (widgetsParam[diff[0].i]) {
              this.widgets.push(this.convertWidget(diff[0], widgetsParam[diff[0].i]))
            }
          }
        } else if (value.length < this.widgets.length) {
          // Removed
          let diff = this.widgets.filter(x => !value.find(a => x.i === a.i))
          if (diff && diff.length > 0) {
            this.widgets.splice(this.widgets.indexOf(this.widgets.find(x => x.i === diff[0].i)), 1)
          }
        }
      } else {
        // raw init
        this.convertWidgetState()
      }
    }
  },
  computed: {
    initStatus() {
      return this.$store.state.widgets.init
    },
    globalWidgets() {
      return this.$store.state.widgets.widgets
    }
  },
  methods: {
    ...mapActions([
      'initWidget'
    ]),
    convertWidgetState() {
      // Convert vuex widget state to dashboard local state
      this.widgets = []
      if (this.globalWidgets && this.globalWidgets.length > 0) {
        this.globalWidgets.map(widget => {
          // Conversion needs to find widget library (to check availability and also fixed param like minW, minH etc)
          if (widgetsParam[widget.i]) {
            const convertedWidget = this.convertWidget(widget, widgetsParam[widget.i])
            if (convertedWidget) {
              this.widgets.push(convertedWidget)
            }
          }
        })
      }
    },
    convertWidget(globalWidget, paramWidget) {
      if (globalWidget && paramWidget) {
        const result = { ...globalWidget, ...paramWidget }
        return result
      } else {
        return undefined
      }
    },
    layoutUpdatedEvent(newLayout) {
      // Move event and resize event only return the widget that is being moved/resize
      // it does not return the affected widgets
      // so for this, we will detect changes in layout and send all info back
      this.$store.dispatch('adjustWidget', newLayout)
    },
    startTour() {
      if (this.$refs.tour) {
        this.$refs.tour.startTour()
      }
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.initWidget()
    } else {
      // For init status !== 1 (we will watch globalWidgets for changes)
      // Might be coming back from other place
      this.convertWidgetState()
    }
  },
  components: {
    GridLayout,
    GridItem,
    DateDisplay,
    WidgetMenu
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/base.scss";
.dashTitle {
  // height: 50px;
}
// As flexible grid has a defined set of rules
// Its hard to make it fit to responsive design
// Thus, for now we will set a min width to dashboard content
.dashboard {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow: hidden;
}
// Overwrite grid css
.vue-grid-item.vue-grid-placeholder {
  background: $primary !important;
  opacity: 0.2;
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>
